
import slugify from '@sindresorhus/slugify'
import StoryblokImage from '~/components/StoryblokImage.vue'
import storyblok from '~/mixins/storyblok'

export default {
  name: 'FAQ',
  components: { StoryblokImage },
  mixins: [storyblok],
  async asyncData({ $db, $storyblok, error, params }) {
    const {
      id,
      title,
      heroPicture,
      categories
    } = await $storyblok.getStoryBySlug('foire-aux-questions')
    const slugedCategories = categories.map((c) => ({
      ...c,
      slug: slugify(c.title),
      questions: c.questions.map((q) => ({ ...q, slug: slugify(q.title) }))
    }))
    return { id, title, heroPicture, categories: slugedCategories }
  },
  head() {
    return {
      title: 'FAQ'
    }
  },
  computed: {
    current() {
      return this.$route.params.question
    }
  },
  mounted() {
    this.listenStoryblokChanges(this.id, (event) => {
      const { title, heroPicture, categories } = event.story.content
      this.title = title
      this.heroPicture = heroPicture
      this.categories = categories
    })
    if (this.current && document.getElementById(this.current)) {
      const currentEl = document.getElementById(this.current)
      if (currentEl) {
        const { top } = currentEl.getBoundingClientRect()
        window.scroll(0, top + window.scrollY)
        currentEl.nextElementSibling.open = true
      }
    }
  },
  methods: {
    changeUrl(e) {
      const {
        dataset: { slug },
        open
      } = e.target
      if (!open) return
      this.$router.push({
        name: 'foire-aux-questions-question',
        params: { question: slug }
      })
    }
  }
}
